import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';

import {
  LocationRadiusSelectChevronHolder,
  LocationRadiusSelectHolder,
  LocationRadiusSelectLeftIconHolder,
  LocationRadiusSelectStyled,
} from './LocationRadiusSelect.styled';

export type LocationRadiusSelectHandle =
  | {
      type: 'controlled';
      radius: string;
      onChange: (newRadius: string) => void;
    }
  | {
      type: 'uncontrolled';
      radius: string;
    };

type Props = {
  handle: LocationRadiusSelectHandle;
  options: { label: string; value: string }[];
  disabled: boolean;
  qaId: string;
  fullWidth?: boolean;
};

export function LocationRadiusSelect({
  handle,
  options,
  disabled,
  qaId,
  fullWidth,
}: Props) {
  const { i18n } = useI18n();

  return (
    <LocationRadiusSelectHolder>
      <LocationRadiusSelectLeftIconHolder>
        <Icon aria-hidden name="bulls-eye" size={24} />
      </LocationRadiusSelectLeftIconHolder>

      <LocationRadiusSelectStyled
        key={
          handle.type === 'uncontrolled'
            ? `uncontrolled-${handle.radius}`
            : 'controlled'
        }
        name="radius"
        // oxlint-disable-next-line react/jsx-props-no-spreading
        {...(handle.type === 'controlled'
          ? {
              value: handle.radius,
              onChange: (event) => {
                if (handle.type === 'controlled')
                  handle.onChange(event.target.value);
              },
            }
          : { defaultValue: handle.radius })}
        disabled={disabled}
        $fullWidth={Boolean(fullWidth)}
        aria-label={i18n('Search radius')}
        data-qa-id={qaId}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </LocationRadiusSelectStyled>

      <LocationRadiusSelectChevronHolder>
        <Icon aria-hidden name="chevron-down" size={16} />
      </LocationRadiusSelectChevronHolder>
    </LocationRadiusSelectHolder>
  );
}
